import { useState } from "react";

const galleryImages = [
    {
        title: "Hospital Building",
        cover: "/images/Gallery/building/1.jpg",
        images: [
            { src: "/images/Gallery/building/1.jpg", text: "The main hospital building with modern architecture and easy patient access." },
            { src: "/images/Gallery/building/2.jpg", text: "Comfortable waiting area designed for patient convenience." },
            { src: "/images/Gallery/building/3.jpg", text: "Advanced support and utility area ensuring smooth hospital operations." },
            { src: "/images/Gallery/building/4.jpg", text: "Reception desk for OPD registration and patient assistance." },
            { src: "/images/Gallery/building/5.jpg", text: "Well-maintained electrical panel ensuring safety and uninterrupted services." },
            { src: "/images/Gallery/building/6.jpg", text: "Power backup and generator system providing 24×7 electricity support." },
        ],
    },
    {
        title: "Reception & OPD",
        cover: "/images/Gallery/opd/1.jpg",
        images: [
            { src: "/images/Gallery/opd/1.jpg", text: "OPD reception area with organized patient registration system." },
            { src: "/images/Gallery/opd/2.jpg", text: "Spacious OPD waiting area with seating arrangements." },
            { src: "/images/Gallery/opd/3.jpg", text: "Dedicated consultation rooms for doctors and patients." },
        ],
    },
    {
        title: "Hospital Opening Ceremony",
        cover: "/images/Gallery/opening/1.jpg",
        images: [
            { src: "/images/Gallery/opening/1.jpg", text: "The hospital opening ceremony with doctors, staff, and respected guests." },
            { src: "/images/Gallery/opening/2.jpg", text: "Traditional inauguration ceremony marking the beginning of healthcare services." },
            { src: "/images/Gallery/opening/3.jpg", text: "Community members and visitors attending the hospital opening event." },
            { src: "/images/Gallery/opening/4.jpg", text: "A memorable moment celebrating trust, care, and medical excellence." },
        ],
    },
    {
        title: "Operation Theatre",
        cover: "/images/Gallery/ot/1.jpg",
        images: [
            { src: "/images/Gallery/ot/1.jpg", text: "State-of-the-art operation theatre with sterile environment." },
            { src: "/images/Gallery/ot/2.jpg", text: "Advanced surgical equipment ensuring precision and safety." },
            { src: "/images/Gallery/ot/3.jpg", text: "Well-maintained OT setup following strict hygiene protocols." },
            { src: "/images/Gallery/ot/4.jpg", text: "Modern monitoring systems for patient safety during surgery." },
            { src: "/images/Gallery/ot/5.jpg", text: "Dedicated OT support area for smooth surgical operations." },
        ],
    },
    {
        title: "Patient Ward",
        cover: "/images/Gallery/ward/1.jpg",
        images: [
            { src: "/images/Gallery/ward/1.jpg", text: "Clean and comfortable patient ward for recovery." },
            { src: "/images/Gallery/ward/2.jpg", text: "Spacious rooms with proper ventilation and lighting." },
            { src: "/images/Gallery/ward/3.jpg", text: "Hygienic patient beds with regular maintenance." },
            { src: "/images/Gallery/ward/4.jpg", text: "Calm and peaceful ward environment for patient comfort." },
            { src: "/images/Gallery/ward/5.jpg", text: "Dedicated nursing support available round the clock." },
        ],
    },
    {
        title: "Medical Staff",
        cover: "/images/Gallery/staff/1.jpg",
        images: [
            { src: "/images/Gallery/staff/1.jpg", text: "Our doctors carefully examine patients and provide accurate medical guidance." },
            { src: "/images/Gallery/staff/2.jpg", text: "Skilled nursing staff offering continuous patient monitoring and care." },
            { src: "/images/Gallery/staff/3.jpg", text: "Medical staff assisting patients with procedures and routine check-ups." },
            { src: "/images/Gallery/staff/4.jpg", text: "Friendly staff managing appointments and patient coordination efficiently." },
            { src: "/images/Gallery/staff/5.jpg", text: "Hospital administration ensuring smooth and organized healthcare services." },
            { src: "/images/Gallery/staff/6.jpg", text: "A dedicated medical team committed to patient health, safety, and comfort." },
        ],
    },
];

function Gallery() {
    const [activeGallery, setActiveGallery] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <section className="py-12">
            <div className="max-w-7xl mx-auto px-6">

                {/* 🔵 OUTER GRADIENT BOX */}
                <div
                    className="rounded-3xl p-10 shadow-2xl"
                    style={{
                        background:
                            "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                    }}
                >
                    {/* HEADING */}
                    <div className="text-center mb-10">
                        <h1 className="text-3xl md:text-4xl font-bold text-white">
                            Hospital Gallery
                        </h1>
                        <p className="mt-3 text-white/90 max-w-2xl mx-auto">
                            A glimpse of Gavli Hospital’s modern facilities, infrastructure,
                            and patient-friendly environment.
                        </p>
                    </div>

                    {/* 🔹 INNER GRADIENT BOX (SAME AS OUTER) */}
                    <div
                        className="rounded-3xl p-8 shadow-xl"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                        }}
                    >
                        {/* GALLERY CARDS */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                            {galleryImages.map((item, index) => (
                                <div
                                    key={index}
                                    onClick={() => {
                                        setActiveGallery(item);
                                        setActiveIndex(0);
                                    }}
                                    className="cursor-pointer group rounded-2xl overflow-hidden shadow-xl bg-white"
                                >
                                    <img
                                        src={item.cover}
                                        alt={item.title}
                                        className="w-full h-56 object-cover group-hover:scale-105 transition duration-300"
                                    />
                                    <div className="p-4 text-center">
                                        <h3 className="text-lg font-semibold text-[#0b3c78]">
                                            {item.title}
                                        </h3>
                                        <p className="text-sm text-gray-600">
                                            Click to view details
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* MODAL */}
                {activeGallery && (
                    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center">
                        <div className="bg-white/95 backdrop-blur max-w-6xl w-full mx-4 rounded-2xl shadow-2xl relative overflow-hidden">
                            <button
                                onClick={() => setActiveGallery(null)}
                                className="absolute top-4 right-4 text-2xl font-bold text-gray-600 hover:text-red-600 z-10"
                            >
                                ✕
                            </button>

                            <div className="grid grid-cols-1 md:grid-cols-2">
                                <div className="bg-black flex items-center justify-center">
                                    <img
                                        src={activeGallery.images[activeIndex].src}
                                        alt=""
                                        className="max-h-[90vh] object-contain"
                                    />
                                </div>

                                <div className="p-6">
                                    <h2 className="text-2xl font-semibold mb-4 text-[#0b3c78]">
                                        {activeGallery.title}
                                    </h2>
                                    <p className="text-gray-700 mb-6 leading-relaxed">
                                        {activeGallery.images[activeIndex].text}
                                    </p>

                                    <div className="grid grid-cols-3 gap-3">
                                        {activeGallery.images.map((img, i) => (
                                            <img
                                                key={i}
                                                src={img.src}
                                                alt=""
                                                onClick={() => setActiveIndex(i)}
                                                className={`cursor-pointer h-20 object-cover rounded-lg border-2 transition
                        ${i === activeIndex
                                                        ? "border-blue-600"
                                                        : "border-transparent hover:border-blue-300"
                                                    }`}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </section>
    );
}

export default Gallery;
